import { V4 } from '@moleculeone/utils';

export default class Bonding {
  constructor(length, factor) {
    this.length = length;
    this.factor = factor;
  }

  apply(mol, forces) {
    for (const bond of Object.values(mol.bonds)) {
      const vector = V4.sub(mol.positions[bond.end], mol.positions[bond.start]);
      const distance = V4.norm(vector);
      const strength = (distance - this.length) / 100;
      // so d(force)/d(norm) = 1/100 * factor
      const force = V4.normal(vector, strength * this.factor);

      forces[bond.start].push(force);
      forces[bond.end].push(V4.scale(force, -1));
    }
  }
}
